import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ai-quiz-document-upload-container"
};
const _hoisted_2 = {
  class: "upload-block"
};
const _hoisted_3 = {
  class: "upload-button-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_upload = _resolveComponent("el-upload");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
    class: "upload-field",
    "file-list": _ctx.documents,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _ctx.documents = $event),
    accept: _ctx.acceptedDocTypes,
    disabled: _ctx.disabled,
    multiple: "",
    "on-remove": _ctx.handleRemove,
    "on-success": _ctx.onFileUpload
  }, {
    default: _withCtx(() => [_createVNode(_component_standard_button, {
      outlined: true,
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
        icon: "upload-outline",
        size: "default"
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiQuizGeneration.uploadedDocument.btnLabel')), 1)])]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  }, 8, ["file-list", "accept", "disabled", "on-remove", "on-success"])])]);
}